import { useState } from 'react';
import { Tab, TabItem } from '../../../shared/ui/tab';
import { TitledPanel } from '../../../shared/ui/dashboard/titledPanel/titledPanel';
import { LargeTile } from '../../../shared/ui/grid/gridsystem';
import { WideLayout } from '../../../shared/layout/widelayout';
import { Panel } from '../../../shared/ui/panel/panels';
import { useLayoutStore, usePortalStore } from '../../../stores/portalStore';
import { UserManagementConfig } from './userManagementConfig';
import { CompaniesConfig } from './companiesConfig';
import { useResponsive } from '../../../hooks/useResponsive';
import { SpreadsheetUploadConfig } from './spreadsheetUploadConfig';
import { SapProductBranchConfig } from './sapProductBranchConfig';

export const ConfigurationPage = () => {
    const currentUser = usePortalStore((state) => state.currentUser);
    if (!currentUser.isAdmin) {
        return (
            <WideLayout
                outlet={
                    <TitledPanel height="100vh" title="Acesso Negado">
                        <h3>Você não tem permissão para acessar esta página.</h3>
                    </TitledPanel>
                }
            ></WideLayout>
        );
    }
    return <WideLayout outlet={<MainPanels />}></WideLayout>;
};

const MainPanels = () => {
    const contentWidth = useLayoutStore((state) => state.contentWidth);
    const { isDesktop } = useResponsive();
    const [currentConfigPage, setCurrentConfigPage] = useState(0);
    const configPages = [];
    configPages[0] = <UserManagementConfig />;
    configPages[1] = <SpreadsheetUploadConfig />;
    configPages[2] = <CompaniesConfig />;
    configPages[3] = <SapProductBranchConfig />;

    const containerWidth = isDesktop && contentWidth ? contentWidth : '100%';

    return (
        <LargeTile
            style={{
                maxWidth: containerWidth,
                margin: '15px',
                display: 'flex',
                flexDirection: 'column',
                // altura relativa ao container pai (já dimensionado ao viewport),
                // descontando a margem vertical para não estourar o espaço disponível
                height: 'calc(100% - 30px)',
            }}
        >
            <h3>Configurações</h3>
            <Panel
                overflow={'hidden'}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                }}
            >
                <div style={{ borderBottom: '1px solid #e6e6e6' }}>
                    <Tab>
                        <TabItem
                            style={{
                                borderBottom:
                                    currentConfigPage === 0
                                        ? '3px solid #58a61e'
                                        : '3px solid transparent',
                                opacity: currentConfigPage === 0 ? 1 : 0.7,
                            }}
                            onClick={() => setCurrentConfigPage(0)}
                        >
                            Gerenciamento de Usuários
                        </TabItem>

                        <TabItem
                            style={{
                                borderBottom:
                                    currentConfigPage === 1
                                        ? '3px solid #58a61e'
                                        : '3px solid transparent',
                                opacity: currentConfigPage === 1 ? 1 : 0.7,
                            }}
                            onClick={() => setCurrentConfigPage(1)}
                        >
                            Upload da Planilha
                        </TabItem>
                        <TabItem
                            style={{
                                borderBottom:
                                    currentConfigPage === 2
                                        ? '3px solid #58a61e'
                                        : '3px solid transparent',

                                opacity: currentConfigPage === 2 ? 1 : 0.7,
                            }}
                            onClick={() => setCurrentConfigPage(2)}
                        >
                            Gerenciamento de Empresas
                        </TabItem>

                        <TabItem
                            style={{
                                borderBottom:
                                    currentConfigPage === 3
                                        ? '3px solid #58a61e'
                                        : '3px solid transparent',
                                opacity: currentConfigPage === 3 ? 1 : 0.7,
                            }}
                            onClick={() => setCurrentConfigPage(3)}
                        >
                            Gerenciamento de Produtos
                        </TabItem>
                    </Tab>
                </div>
                <div
                    style={{
                        padding: '15px',
                        overflow: currentConfigPage === 0 || currentConfigPage === 2 || currentConfigPage === 3 ? 'hidden' : 'auto',
                        boxSizing: 'border-box',
                        minHeight: 0,
                        flex: 1,
                    }}
                >
                    {configPages[currentConfigPage]}
                </div>
            </Panel>
        </LargeTile>
    );
};
